import { io as socketIO } from 'socket.io-client'
import { REST_API } from 'src/constants/DefaultValues'

/**
 * Optional handshake token for clients that store JWT in localStorage.
 * Primary auth remains httpOnly cookie via withCredentials (not readable from JS).
 */
function getOptionalHandshakeToken() {
  try {
    if (typeof localStorage === 'undefined') return null
    return localStorage.getItem('accessToken') || null
  } catch (e) {
    return null
  }
}

/**
 * Build Socket.IO options that work behind Namecheap / path-based proxies.
 * e.g. REST_API = https://mayura.skyniche.website/backend/
 *   -> origin https://mayura.skyniche.website
 *   -> path   /backend/socket.io
 */
export function getSocketConnection() {
  let origin = REST_API.replace(/\/$/, '')
  let path = '/socket.io'

  try {
    const url = new URL(REST_API)
    origin = url.origin
    const basePath = url.pathname.replace(/\/$/, '')
    // If API is mounted under /backend (common Namecheap reverse-proxy),
    // Socket.IO must use /backend/socket.io — not namespace "/backend".
    if (basePath && basePath !== '/') {
      path = `${basePath}/socket.io`
    }
  } catch (e) {
    // keep defaults
  }

  const token = getOptionalHandshakeToken()

  const socket = socketIO(origin, {
    path,
    withCredentials: true,
    ...(token ? { auth: { token } } : {}),
    // Polling first: shared hosts often break websocket upgrades
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
  })

  return { socket, origin, path }
}
